import React from 'react';
import PropTypes from 'prop-types';
import {Spinner} from "react-bootstrap";

MySpinner.propTypes = {};

function MySpinner() {
    return (
        <Spinner variant={"primary"} animation="border"/>
    );
}

export default MySpinner;